export default {
  COMMIT_DEMO_REQUEST_SUCCESS: 'COMMIT_DEMO_REQUEST_SUCCESS',
  RESET_PUBLIC_STATE: 'RESET_PUBLIC_STATE',
};
